import { Get, Set } from "../../../../../Request";

export const changepass = async data => {
  return await Get({
    url: "/client/change_password",
    stat: true,
    data: data,
  }).then(data => {
    return data;
  });
};

export const editprofile = async data => {
  return await Set({
    url: "/client/profile_update",
    neddata: true,
    data: data,
  }).then(data => {
    return data;
  });
};

export const GetData = async (limit = 15, page = null) => {
  return await Get({
    url: "/client/profile",
  }).then(data => {
    return data;
  });
};
